import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@business/assets/css/overrideReactToastify.css';
import React from 'react';
import { Alert } from '../Alert';

export interface ToastProps {
  message?: string | React.ReactNode;
  type: 'success' | 'error' | 'loading';
  progressValue?: number;
  totalValue?: number;
  isAlert?: boolean;
  alertProps?: Record<string, any>;
}

export const showToast = ({
  message,
  type,
  progressValue,
  totalValue,
  isAlert = false,
  alertProps
}: ToastProps) => {
  const autoClose = isAlert
    ? typeof alertProps?.autoHide === 'undefined' || alertProps?.autoHide
      ? 10000
      : false
    : type === 'loading'
      ? false
      : 5000;
  const toastConfig: ToastOptions = isAlert
    ? ({
        position: 'top-right' as const,
        closeOnClick: true,
        hideProgressBar: true,
        autoClose,
        icon: false,
        style: {
          padding: 0, // remove Toastify default padding
          background: 'transparent'
        },
        closeButton: false
      } as const)
    : ({
        position: 'top-right' as const,
        autoClose,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: type === 'loading' ? progressValue! / totalValue! : undefined
      } as const);

  const renderContent = () => {
    if (
      type === 'loading' &&
      progressValue !== undefined &&
      totalValue !== undefined
    ) {
      return (
        <div className="flex flex-col gap-2">
          <div>{message}</div>
          <div className="text-sm">
            {progressValue} out of {totalValue} completed
          </div>
        </div>
      );
    }
    if (isAlert) {
      return (
        <Alert
          {...alertProps}
          className="w-full"
          autoHide={false}
          isFocusable={false}
        />
      );
    }
    return message;
  };

  switch (type) {
    case 'success':
      toast.success(renderContent(), toastConfig);
      break;
    case 'error':
      toast.error(renderContent(), toastConfig);
      break;
    case 'loading':
      toast.loading(renderContent(), toastConfig);
      break;
    default:
      toast(renderContent(), toastConfig);
  }
};

// Usage examples:
// showToast({ message: "Successfully uploaded!", type: "success" });
// showToast({ message: "Error occurred while uploading.", type: "error" });
// showToast({ message: "Uploading files...", type: "loading", progressValue: 2, totalValue: 5 });
